import { jsx as _jsx } from "react/jsx-runtime";
import { exists, formatTimestamp, generateHex, parseTimeString } from '@nu-art/ts-common';
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
const Format_DateByDayPattern = 'DD/MM/YYYY';
export class QDatePicker extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return undefined;
    }
    render() {
        return _jsx(DatePicker.default, { selected: this.props.selected, dateFormat: "dd/MM/yyyy", portalId: generateHex(8), onChange: (date) => {
                if (!exists(date)) {
                    this.props.onChange();
                }
                else {
                    const timestampString = formatTimestamp(Format_DateByDayPattern, date.getTime());
                    this.props.onChange(parseTimeString(timestampString, Format_DateByDayPattern));
                }
                this.forceUpdate();
            } });
    }
}
export const normalizeDateByFormat = (timeAsMillis, pattern = Format_DateByDayPattern) => {
    return parseTimeString(formatTimestamp(pattern, timeAsMillis), pattern);
};
//# sourceMappingURL=QDatePicker.js.map